<template>
  <div>
    <b-card
      header="Details"
      header-tag="h4"
      header-bg-variant="white"
      class="mt-3"
    >
      <b-container>
        <b-form-group
          label="Name"
          label-cols-lg="3"
        >
          <b-form-input
            v-model="name"
            required
          ></b-form-input>
        </b-form-group>

        <!-- bug with text entry in b-form-textarea, have to use normal textarea -->
        <b-form-group
          label="Description"
          label-cols-lg="3"
        >
          <textarea
            :rows="5"
            v-model="description"
            class="form-control"
          ></textarea>
          <b-form-text>This will only be seen in Oscar</b-form-text>
        </b-form-group>

        <b-form-group
          label="Email Subject"
          label-cols-lg="3"
        >
          <b-form-input
            v-model="email_subject"
            required
          ></b-form-input>
          <b-form-text>Email subject see by the recipients</b-form-text>
        </b-form-group>

        <b-form-group
          label="Sender Name"
          label-cols-lg="3"
        >
          <b-form-input
            v-model="sender_name"
            required
          ></b-form-input>
          <b-form-text>The full name the recipients will see the campaign was by</b-form-text>
        </b-form-group>

        <b-form-group
          label="Sender Email"
          label-cols-lg="3"
        >
          <b-form-input
            type="email"
            v-model="sender_email"
            required
          ></b-form-input>
          <b-form-text>The email address the recipients will see the campaign was sent from</b-form-text>
        </b-form-group>

        <b-form-group
          label="Frequency"
          label-cols-lg="3"
        >
          <b-form-input
            type="number"
            v-model="frequency"
            required
          ></b-form-input>
          <b-form-text>Don't send again for this many more days</b-form-text>
        </b-form-group>

        <b-form-group
          label="Limit"
          label-cols-lg="3"
        >
          <b-form-input
            type="number"
            v-model="limit"
            required
          ></b-form-input>
          <b-form-text>Don't send more than this many times</b-form-text>
        </b-form-group>

        <b-form-group
          label="Days Allowed to Send"
          label-cols-lg="3"
        >
          <b-form-checkbox-group
            button-variant="outline-primary"
            :options="daysOfWeek"
            v-model="send_days_of_week"
          ></b-form-checkbox-group>
        </b-form-group>

        <b-form-group
          label="Time Allowed to Send From"
          label-cols-lg="3"
        >
          <time-picker
            :step-size="30"
            v-model="send_time_from"
          ></time-picker>
        </b-form-group>

        <b-form-group
          label="Time Allowed to Send To"
          label-cols-lg="3"
        >
          <time-picker
            :step-size="30"
            :validity="sendTimeValidityMessage"
            v-model="send_time_to"
          ></time-picker>
        </b-form-group>

        <b-form-group
          label="Days After Previous Stage"
          label-cols-lg="3"
        >
          <b-form-input
            type="number"
            v-model="days_after_stage"
            required
          ></b-form-input>
          <b-form-text>Number of days to wait between the previous stage before triggering this stage</b-form-text>
        </b-form-group>
      </b-container>
    </b-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TimePicker from '../components/TimePicker'
import store from '../store'

export default {
  components: {
    TimePicker
  },

  beforeRouteEnter(to, from, next) {
    store.dispatch('stages/updateStageHasChanges', false)

    Promise.all([
      store.dispatch('stages/fetchAll', to.params.id),
      (
        'stageid' in to.params
          ? store.dispatch('stages/fetchOne', to.params.stageid)
          : store.dispatch('stages/newStage', to.params.id)
      )
    ]).then(next)
  },

  beforeRouteLeave(to, from, next) {
    if (this.stageHasChanges) {
      next(confirm('You have unsaved changes, are you sure you want to leave?'))
    } else {
      next()
    }
  },

  data() {
    return {
      daysOfWeek: [
        { value: 'sun', text: 'Sunday' },
        { value: 'mon', text: 'Monday' },
        { value: 'tues', text: 'Tuesday' },
        { value: 'wed', text: 'Wednesday' },
        { value: 'thurs', text: 'Thursday' },
        { value: 'fri', text: 'Friday' },
        { value: 'sat', text: 'Saturday' }
      ]
    }
  },

  computed: {
    ...mapState('stages', [
      'stage',
      'stages',
      'stageHasChanges'
    ]),

    sendTimeValidityMessage() {
      return parseInt(this.send_time_from, 10) > parseInt(this.send_time_to, 10) ? 'Send To time must be greater than Send From time' : ''
    },

    name: {
      get() { return this.$store.state.stages.stage.name },
      set(value) { this.updateAttribute({ attribute: 'name', value }) }
    },

    description: {
      get() { return this.$store.state.stages.stage.description },
      set(value) { this.updateAttribute({ attribute: 'description', value }) }
    },

    email_subject: {
      get() { return this.$store.state.stages.stage.email_subject },
      set(value) { this.updateAttribute({ attribute: 'email_subject', value }) }
    },

    email_body: {
      get() { return this.$store.state.stages.stage.email_body },
      set(value) { this.updateAttribute({ attribute: 'email_body', value }) }
    },

    sender_name: {
      get() { return this.$store.state.stages.stage.sender_name },
      set(value) { this.updateAttribute({ attribute: 'sender_name', value }) }
    },

    sender_email: {
      get() { return this.$store.state.stages.stage.sender_email },
      set(value) { this.updateAttribute({ attribute: 'sender_email', value }) }
    },

    // convert to and from comma separated list, eg: mon,tues,wed
    send_days_of_week: {
      get() {
        let value = this.$store.state.stages.stage.send_days_of_week
        return value ? value.split(',') : []
      },
      set(value) { this.updateAttribute({ attribute: 'send_days_of_week', value: value.join(',') }) }
    },

    send_time_from: {
      get() { return this.$store.state.stages.stage.send_time_from },
      set(value) { this.updateAttribute({ attribute: 'send_time_from', value }) }
    },

    send_time_to: {
      get() { return this.$store.state.stages.stage.send_time_to },
      set(value) { this.updateAttribute({ attribute: 'send_time_to', value }) }
    },

    frequency: {
      get() { return this.$store.state.stages.stage.frequency },
      set(value) { this.updateAttribute({ attribute: 'frequency', value }) }
    },

    limit: {
      get() { return this.$store.state.stages.stage.limit },
      set(value) { this.updateAttribute({ attribute: 'limit', value }) }
    },

    days_after_stage: {
      get() { return this.$store.state.stages.stage.days_after_stage },
      set(value) { this.updateAttribute({ attribute: 'days_after_stage', value }) }
    }
  },

  methods: {
    ...mapActions('stages', [
      'updateAttribute',
      'updateStageHasChanges'
    ])
  },

  watch: {
    stage: {
      handler(val, oldVal) {
        this.updateStageHasChanges(true)
      },
      deep: true
    }
  }
}
</script>
